import { useQuery } from "@apollo/client";
import { GET_COLORS } from "../../../../lib/apollo/gql/artGqls";

function useArtColorSelector() {
  const { data, loading } = useQuery(GET_COLORS);

  return {
    models: {
      loading,
      data: data?.getColors,
    },
  };
}

export default useArtColorSelector;
